import type { StreamServer } from '../types';
import { newId } from './uuid';

export function newStreamServer(
  partial: Pick<StreamServer, 'name' | 'server' | 'username' | 'password'> &
    Partial<
      Pick<StreamServer, 'id' | 'sourceKind' | 'restrictConnectionToCountry' | 'connectionCountryCode'>
    >,
): StreamServer {
  const now = new Date().toISOString();
  const restrict = Boolean(partial.restrictConnectionToCountry);
  return {
    id: partial.id ?? newId(),
    name: partial.name.trim(),
    server: partial.server.trim(),
    username: partial.username.trim(),
    password: partial.password,
    createdAt: now,
    updatedAt: now,
    sourceKind: partial.sourceKind ?? 'xtream',
    restrictConnectionToCountry: restrict,
    connectionCountryCode:
      restrict && partial.connectionCountryCode?.trim()
        ? partial.connectionCountryCode.trim().toUpperCase()
        : undefined,
  };
}
